"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "show-hide-toggle": "ObfuscationToggle__show-hide-toggle__p-LO6",
  "showHideToggle": "ObfuscationToggle__show-hide-toggle__p-LO6"
}; 
require('./ObfuscationToggle.css');
var ObfuscationToggle = /*#__PURE__*/function (_React$Component) {
  function ObfuscationToggle(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ObfuscationToggle);
    _this = _callSuper(this, ObfuscationToggle, [props]);
    (0, _defineProperty2.default)(_this, "handleClick", function () {
      var currentValue = _this.state.obfuscated;
      _this.setState({
        obfuscated: !currentValue
      });
    });
    (0, _defineProperty2.default)(_this, "handleKeyDown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        _this.handleClick();
      }
    });
    _this.state = {
      obfuscated: props.obfuscated,
      obfuscatedValue: Array(props.value.length).fill(props.obfuscationChar)
    };
    return _this;
  }
  (0, _inherits2.default)(ObfuscationToggle, _React$Component);
  return (0, _createClass2.default)(ObfuscationToggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        testId = _this$props.testId;
      var _this$state = this.state,
        obfuscated = _this$state.obfuscated,
        obfuscatedValue = _this$state.obfuscatedValue;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testId
      }, /*#__PURE__*/_react.default.createElement("span", null, obfuscated ? obfuscatedValue : value), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.showHideToggle,
        onClick: this.handleClick,
        role: "button",
        tabIndex: "0",
        onKeyDown: this.handleKeyDown
      }, obfuscated ? 'Show' : 'Hide'));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(ObfuscationToggle, "propTypes", {
  value: _propTypes.default.string.isRequired,
  obfuscated: _propTypes.default.bool,
  obfuscationChar: _propTypes.default.string,
  testId: _propTypes.default.string
});
(0, _defineProperty2.default)(ObfuscationToggle, "defaultProps", {
  obfuscationChar: '•',
  obfuscated: true
});
var _default = exports.default = ObfuscationToggle;
//# sourceMappingURL=ObfuscationToggle.js.map